import { render, staticRenderFns } from "./FolderListInfo.vue?vue&type=template&id=54235cac&scoped=true&"
import script from "./FolderListInfo.vue?vue&type=script&lang=js&"
export * from "./FolderListInfo.vue?vue&type=script&lang=js&"
import style0 from "./FolderListInfo.vue?vue&type=style&index=0&id=54235cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54235cac",
  null
  
)

export default component.exports